import React, { useState } from "react";
import { Grid, ListItem, Typography } from "@mui/material";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import useDownloader from "react-use-downloader";

import DownloadSvg from "../../../../styles/svg/download-attachment.svg";
import { deleteAttachments } from "../../../../sevices/apiBoards";
import { getDownloadAttachment } from "../../../../sevices/apiBoards";
import { handleDownloadAttachment } from "../../../../utils/downloadAttachments";
import useToastPromise from "../../../../hooks/useToast";
import { DeleteIcone } from "../../../../components/UI/Icons";
import FormDialog from "../../../../components/Dialog/FormDialog";
import useBoardIdByKey from "../../../../hooks/useBoardIdByKey";

function ListItems({ attachment, refetch, isMobile }) {
  const { id } = useBoardIdByKey();
  const { size, elapsed, percentage, download, cancel, error, isInProgress } =
    useDownloader();
  const queryClient = useQueryClient();
  const [openDeleteDialog, setopenDeleteDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const { showToastPromise } = useToastPromise();

  function deleteAttachment() {
    setopenDeleteDialog(true);
  }

  const { mutate: deleteAttachmentMutate } = useMutation({
    mutationFn: async (data) => {
      return await showToastPromise(deleteAttachments, data);
    },
    onSuccess: (res) => {
      queryClient.invalidateQueries({
        queryKey: [`attachments-${id}`],
      });
      setLoading(false);
      handleClose();
    },
    onError: (error) => {
      console.error("Error Delete Attachments", error);
      setLoading(false);
      handleClose();
    },
  });

  function callback() {
    setLoading(true);
    deleteAttachmentMutate(attachment.board_attachment_id);
  }

  function handleClose() {
    setopenDeleteDialog(false);
  }

  const handleDownload = (e, attachment) => {
    const getResponse = getDownloadAttachment(attachment);
    getResponse
      .then((res) => {
        handleDownloadAttachment(
          res.data.data.responseData.url,
          res.data.data.responseData.filename,
          download
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <>
      {openDeleteDialog && (
        <FormDialog
          open={openDeleteDialog}
          handleClose={handleClose}
          handleSubmit={callback}
          loading={loading}
          buttonTxt={"Delete"}
          title={"Confirmation: Delete Attachment"}
          alignActions={"center"}
          btnColor="#B71D18"
          cancelBtn={true}
          fullWidth={true}>
          <Typography className="align_text_center mb-2">
            Are you sure to delete this attachment?
          </Typography>
        </FormDialog>
      )}
      <ListItem
        key={attachment.board_attachment_id}
        className="list-item"
      >
        <Grid container spacing={2} className="grid-container">
          <Grid
            item
            xs={10}
            className={`grid-item ${isMobile ? "padding-top-0" : ""}`}
          >
            <p className="attachment-name-text">
              {attachment.attachment_name
                ? attachment.attachment_name
                : attachment.attachment}
            </p>
            <p className="attachment-file-name-text">{attachment.attachment}</p>
          </Grid>
          <Grid
            item
            xs={2}
            className={`grid-item-action ${isMobile ? "padding-top-0" : ""}`}
          >
            <div className={isMobile ? "attachment-download-div" : ""}>
              <img
                src={DownloadSvg}
                className="attachment-action-img"
                alt="not found"
                onClick={(e) =>
                  handleDownload(e, attachment.board_attachment_id)
                }
              />
            </div>
            <div onClick={deleteAttachment}>
              <DeleteIcone height={"24px"} width={"24px"} />
            </div>
          </Grid>
        </Grid>
      </ListItem>
    </>
  );
}

export default ListItems;
